import image_pdt from '../../images/sgu/pdt.png'
import image_university from '../../images/sgu/uni.png'
import image_cntt from '../../images/sgu/cntt.png'
export default function SideBar() {
    return (
        <div className="home-page--side-bar w-2/6">
            <div className="sider-bar--title flex items-center">
                Lịch biểu
            </div>
            <div className="sider-bar--feature flex items-center justify-center">
                Thời khóa biểu
            </div>
            {/* <div className="sider-bar--feature flex items-center justify-center">
                Lịch thi
            </div> */}
            {/* <div className="sider-bar--feature flex items-center justify-center">
                Bảo vệ khóa luận
            </div> */}
            <a href="#room">
                <div className="sider-bar--feature flex items-center justify-center">
                    Lịch phòng máy
                </div>
            </a>
            <div className="side-bar--image mt-8">
                <div className="sider-bar--image-item mt-2">
                    <a href="http://daotao.sgu.edu.vn/web/index.php" target="blank"><img src={image_pdt} alt="" /></a>
                </div>
                <div className="sider-bar--image-item mt-2">
                    <a href="https://www.sgu.edu.vn/" target="blank"><img src={image_university} alt="" /></a>
                </div>
                <div className="sider-bar--image-item mt-2">
                    <a href="https://fit.sgu.edu.vn/site/" target="blank"><img src={image_cntt} alt="" /></a>
                </div>
            </div>

        </div>
    )
}